import React from "react";
import { ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { PropTypes } from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { useStyles } from "../../MuiCSS/MiniDrawerStyles";
const ListItemLink = (props) => {
  const classes = useStyles();
  const {
    to,
    open,
    menu,
    menuText,
    icon,
    spacing,
    tooltip,
    openSideBar,
    onClick,
    ...other
  } = props;

  return (
    <Tooltip placement="top" disableHoverListener={!tooltip} disableTouchListener={!tooltip} disableFocusListener={!tooltip} title={openSideBar ? "" : <h6>{tooltip}</h6>}>
      <Box className={classes.appBarIcon} onClick={onClick}>
        <ListItem
          button
          component={to && window.location.pathname != to ? RouterLink : null}
          to={to}
          replace
          {...other}
          style={
            spacing
              ? { paddingLeft: `${spacing}px` }
              : { paddingLeft: "10px", minWidth: "50px" }
          }
        >
          <ListItemIcon style={{ minWidth: "62px" }}>{icon}</ListItemIcon>

          <ListItemText primary={menuText} />
          {open != null ? !open ? <ExpandLess /> : <ExpandMore /> : null}
        </ListItem>
        {open != null && !openSideBar ? (
          <Box className={classes.appBarExpandItem}>
            {!open ? <ExpandLess /> : <ExpandMore />}
          </Box>
        ) : null}
      </Box>
    </Tooltip>
  );
};

ListItemLink.propTypes = {
  open: PropTypes.bool,
  to: PropTypes.string.isRequired,
};

export default ListItemLink;
